import { useEffect, useState } from "react";
import { getBirthdays } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const Birthday = () => {
  const [data, setData] = useState([]);  

  useEffect(() => {
    const fetchData = async () => {
      const birthdayData = await getBirthdays();
      setData(birthdayData);
    };
    fetchData();
  }, []);

 



  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  };
  return (
    <>
      <div className="row">
        <Slider {...settings}>
         
            {data.length > 0 ? data.map((item, index) => (
            <div className="item" key={index}>
              <div className="topperdiv birthday">
                <div className="toppertaj">
                  <LazyLoad>{item.attachments.length > 0 ? (<img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`} className="img-fluid" alt="St. Francis Xavier School" />):(<img alt="St. Francis Xavier School" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/default.png" className="img-fluid" />)}</LazyLoad>
                </div>
                <div className="topperdesc">
                  <p className="name">{item.name}</p>
                  <p className="per">{item.class}</p>
                </div>
              </div>
            </div>
          )) : (
          <div className="item">
          <div className="topperdiv birthday">
            <div className="toppertaj">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/default.png" className="img-fluid" alt="St. Francis Xavier School" /></LazyLoad>
            </div>

            <div className="topperdesc">
              <p className="name">Student Name</p>
              <p className="per">Class</p>
            </div>
          </div>
        </div>
        )}  
 
        </Slider>
      </div>
    </>
  )
}

export default Birthday